import * as React from 'react';

import { useShortNumber } from '@xing-com/crate-social-utils';
import { IconShow } from '@xing-com/icons';
import { PopUpWindow } from '@xing-com/pop-up-window';
import ttt from '@xing-com/ticktricktrack';

import { useViewCounter } from '../../hooks';
import { ViewCounterModal } from '../view-counter-modal/view-counter-modal';

import { Styled } from './view-counter.style';

export type ViewCounterProps = {
  urn: string;
};

export const ViewCounter: React.FC<ViewCounterProps> = ({ urn }) => {
  const { viewsCount } = useViewCounter(urn);
  const { shortNumber } = useShortNumber(viewsCount);
  const [isShown, setIsShown] = React.useState(false);

  return viewsCount > 0 ? (
    <React.Fragment>
      <Styled.ViewCounter
        icon={IconShow}
        size="small"
        data-testid="view-counter"
        onClick={(e: React.MouseEvent) => {
          e.preventDefault();
          ttt.event('PropTrackAction', {
            PropTrackAction: 'social_view_counter_show',
          });
          setIsShown(!isShown);
        }}
      >
        {shortNumber}
      </Styled.ViewCounter>
      <PopUpWindow
        hide={() => setIsShown(false)}
        isShown={isShown}
        onDimmerClick={() => setIsShown(false)}
      >
        <ViewCounterModal viewsCount={viewsCount} />
      </PopUpWindow>
    </React.Fragment>
  ) : null;
};
